export enum CurrencySymbol {
    eur = "€",
    usd = "$"
}

export const getCurrencySymbol = (currency: string): string => {
    return CurrencySymbol[currency as keyof typeof CurrencySymbol];
}